export const MAX_CONTRACT_SIZE = 24 * 1024 * 1024; // 24MB



/** WEBPACK FOOTER **
 ** ./shared/const.js
 **/